import React from 'react';
import Section from './Section'
import './App.css';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import { Button, Collapse } from 'antd/lib';
import 'antd/dist/antd.css';

const {Panel} = Collapse;

class Course extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      showModal: false,
      showAlert: false,
      showAddedAlert: false,
      requiredCourses: ''
    }
  }

  render() {

    return (
      
      <Collapse bordered={true} >
        <Panel 
          style={{'fontWeight': 'bold', "boxShadow": '0 0px 3px rgba(192,192,192,0.05), 0 3px 6px rgba(0,0,0,0.23)', 'marginBottom': '10px'}} 
          header={this.props.data.number + ": " + this.props.data.name}
          extra={this.getCredits()}
          showArrow={false}
        >
          {this.getDescription()}
          {this.getPreReq()}
          <br></br>
          <Section 
            data={this.props.data}
            name={this.props.data.name} 
            num={this.props.data.number} 
            completedCourses={this.props.completedCourses}
            courseKey={this.props.courseKey} 
            Sections={this.props.data.sections} 
            callbackFromSection={this.props.callbackFromCourse} 
            addCartCourse={(data) => this.props.addCartCourse(data)}>
          </Section>

        </Panel>
      </Collapse>
    )
  }

  getCourseButton() {
    let buttonVariant = 'dark';
    let buttonOnClick = () => this.addCourse();
    let buttonText = 'Add Course';

    if(this.props.courseKey in this.props.cartCourses) {
      buttonVariant = 'outline-dark';
      buttonOnClick = () => this.removeCourse();
      buttonText = 'Remove Course'
    }

    return (
      <Button variant={buttonVariant} onClick={buttonOnClick}>
        {buttonText}
      </Button>
    )
  }

  getSections() {
    let sections = [];
    for (let i =0; i < this.props.data.sections.length; i++){
      sections.push (
          <Panel header="Hello" key={i}>
                <p>
                  {JSON.stringify(this.props.data.sections[i].time)}
                  {this.getSubsections(i, this.props.data.sections[i])}
                </p>
              </Panel>
        )
    }

    return (
      <Collapse as defaultActiveKey={['1']}>
        {sections}
      </Collapse>
    )
  }

  getSectionButton(section) {
    let buttonVariant = 'dark';
    let buttonOnClick = (e) => this.addSection(e, section);
    let buttonText = 'Add Section';

    if(this.props.courseKey in this.props.cartCourses) {
      if(section in this.props.cartCourses[this.props.courseKey]) {
        buttonVariant = 'outline-dark';
        buttonOnClick = (e) => this.removeSection(e, section);
        buttonText = 'Remove Section';
      }
    }

    return <Button variant={buttonVariant} onClick={buttonOnClick} style={{position: 'absolute', right: 20}}>{buttonText}</Button>
  }

  getPreReq() {
    var req = this.props.data.requisites;
    var s = "";

    if(req.length === 0) {
      s = "None";
    } else {
        req.forEach(courses => {
          var curr = "";
          s = (s==="") ? s : s + " AND ";
          courses.forEach(course => {
              curr = (curr === "") ? "(" + course : curr + " OR " + course;
            })
            curr += ")";
            s += curr;
        })
    }

    return (
      <div style={{fontWeight:'normal'}}>
        <br></br>
        Pre-requisites: {s}
      </div>
    )
  }

  getKeywords() {
    var keyWordStr = "";
    var keywords = this.props.data.keywords;
    keywords.forEach(key => {
      keyWordStr = (keyWordStr === "") ? key : keyWordStr + ", " + key;
    })

    return (
      <div style={{'fontWeight': 'normal'}}>
        <br></br>
        Keywords: {keyWordStr}
      </div>
    )
  }

  addCourse() {
    var completed = this.props.completedCourses;
    var reqs = this.props.data.requisites;
    var needToComplete = [];

    var allComplete = true;
    for(var i = 0; i < reqs.length; i++) {
      var atLeastOne = false;
      var orComplete = []
      for(var j = 0; j < reqs[i].length; j++) {
        // preReq completed
        if(completed.includes(reqs[i][j])) {
          atLeastOne = true;
          break;
        }
        allComplete = false;
      }

      if(atLeastOne === false) {
        // suggest the user to complete at least one in the list
        needToComplete.push(reqs[i]);
        //this.openAlert();
      }

    }

    if(allComplete === false) {
      var s = this.generatePrereqString(needToComplete);
      // this.state.requiredCourses = s;
      this.setState({requiredCourses: s})
      this.openAlert();
      return;
    }

    this.props.addCartCourse (
      {
        course: this.props.courseKey
      }
    );

    this.openAddedAlert();
  }

  removeCourse() {
    this.props.removeCartCourse (
      {
        course: this.props.courseKey
      }
    );
  }

  addSection(e, section) {
    var completed = this.props.completedCourses;
    var reqs = this.props.data.requisites;
    var needToComplete = [];

    var allComplete = true;
    for(var i = 0; i < reqs.length; i++) {
      var atLeastOne = false;
      var orComplete = []
      for(var j = 0; j < reqs[i].length; j++) {
        // preReq completed
        if(completed.includes(reqs[i][j])) {
          atLeastOne = true;
          break;
        }
        allComplete = false;
      }

      if(atLeastOne === false) {
        // suggest the user to complete at least one in the list
        this.props.openNotification('hello world');
        console.log("helo");
        needToComplete.push(reqs[i]);
        //this.openAlert();
      }

    }

    if(allComplete === false) {
      var s = this.generatePrereqString(needToComplete);
      // this.state.requiredCourses = s;
      this.setState({requiredCourses: s})
      this.openAlert();
      return;
    }

    e.stopPropagation();
    this.props.addCartCourse (
      {
        course: this.props.courseKey,
        section: section
      }
    );

    this.openAddedAlert();
  }

  removeSection(e, section) {
    e.stopPropagation();
    this.props.removeCartCourse (
      {
        course: this.props.courseKey,
        section: section
      }
    );
  }

  addSubsection(e, section, subsection) {
    var completed = this.props.completedCourses;
    var reqs = this.props.data.requisites;
    var needToComplete = [];

    var allComplete = true;
    for(var i = 0; i < reqs.length; i++) {
      var atLeastOne = false;
      var orComplete = []
      for(var j = 0; j < reqs[i].length; j++) {
        // preReq completed
        if(completed.includes(reqs[i][j])) {
          atLeastOne = true;
          break;
        }
        allComplete = false;
      }

      if(atLeastOne === false) {
        // suggest the user to complete at least one in the list
        needToComplete.push(reqs[i]);
        //this.openAlert();
      }

    }

    if(allComplete === false) {
      var s = this.generatePrereqString(needToComplete);
      // this.state.requiredCourses = s;
      this.setState({requiredCourses: s});
      this.openAlert();
      return;
    }

    e.stopPropagation();
    this.props.addCartCourse (
      {
        course: this.props.courseKey,
        section: section,
        subsection: subsection
      }
    );

    this.openAddedAlert();
  }

  removeSubsection(e, section, subsection) {
    e.stopPropagation();
    this.props.removeCartCourse (
      {
        course: this.props.courseKey,
        section: section,
        subsection: subsection
      }
    );

  }

  getSubsections(sectionKey, sectionValue) {
    let subsections = [];

    for (let i =0; i < sectionValue.subsections.length; i++){  
    subsections.push (
        <Card key={i}>
          <Accordion.Toggle as={Card.Header} variant="link" eventKey={i} style={{height: 63, display: 'flex', alignItems: 'center'}}>
            {sectionValue.subsections[i].number}
            {this.getSubsectionButton(sectionKey, i)}
          </Accordion.Toggle>
          <Accordion.Collapse eventKey={i}>
            <Card.Body>
              {JSON.stringify(sectionValue.subsections[i].time)}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      )
    }

    return (
      <Accordion defaultActiveKey="0">
        {subsections}
      </Accordion>
    )
  }

  getSubsectionButton(section, subsection) {
    let buttonVariant = 'dark';
    let buttonOnClick = (e) => this.addSubsection(e, section, subsection);
    let buttonText = 'Add Subsection';

    if(this.props.courseKey in this.props.cartCourses) {
      if(section in this.props.cartCourses[this.props.courseKey]) {
        if(this.props.cartCourses[this.props.courseKey][section].indexOf(subsection) > -1) {
          buttonVariant = 'outline-dark';
          buttonOnClick = (e) => this.removeSubsection(e, section, subsection);
          buttonText = 'Remove Subsection';
        }
      }
    }

    return <Button variant={buttonVariant} onClick={buttonOnClick} style={{position: 'absolute', right: 20}}>{buttonText}</Button>
  }

  openModal() {
    this.setState({showModal: true});
  }

  closeModal() {
    this.setState({showModal: false});
  }

  setExpanded(value) {
    this.setState({expanded: value});
  }

  getExpansionButton() {
    let buttonText = '▼';
    let buttonOnClick = () => this.setExpanded(true);

    if(this.state.expanded) {
      buttonText = '▲';
      buttonOnClick = () => this.setExpanded(false)
    }

    return (
      <Button variant='outline-dark' style={{width: 25, height: 25, fontSize: 12, padding: 0, position: 'absolute', right: 20, top: 20}} onClick={buttonOnClick}>{buttonText}</Button>
    )
  }

  getDescription() {
    // if(this.state.expanded) {
      return (
        <div style={{'fontWeight': 'normal'}}>
          {this.props.data.description}
        </div>
      )
    // }
  }

  getCredits() {
    if(this.props.data.credits === 1)
      return '1 Cr.';
    else
      return this.props.data.credits + ' Cr.';
  }

  openAlert() {
    this.setState({showAlert: true});
  }

  closeAlert() {
    this.setState({showAlert: false});
  }

  openAddedAlert() {
    this.setState({showAddedAlert: true});
  }

  closeAddedAlert() {
    this.setState({showAddedAlert: false});
  }

  generatePrereqString(req) {
    var s = "Before you take the course, ";
    if(req.length === 0) {
      s = "None";
      return;
    } else {
        req.forEach(courses => {
          var curr = "";
          s = (s==="Before you take the course, ") ? s : s + " and ";
          courses.forEach(course => {
              console.log(course);
              curr = (curr === "") ? "you have to complete: " + course : curr + " or " + course;
            })
            curr += "";
            s += curr;
        })
    }
    return s;
  }
}

export default Course;
